export const routes = {
    statements: "/statements",
    accounts: "/accounts",
    billing: "/billing",
    parties: "/parties",
    myCompanies: "/companies",
    companySettings: "/settings",
    lhvConnect: "/integration/lhv/",
    wiseConnection: "/integration/wise/",
    rules: "/rules",
    previewForPrinting: "/preview/tx/:id",
    singleStatement: "/statement/:id",

    documentsUpload: "/documents/upload",
    advice: "/advice",
    myCompany: "/my/company",

    knowledgeBase: "/knowledge-base/info",
    clientDocsTemplates: "/knowledge-base/templates",
    clientDocsTemplatesOpen: "/knowledge-base/templates/open/:templateId",

    addEmployee: "/employees/new",
    myClients: "/clients/list",
    salesInvoice: "/invoices/sale/:id",
    newSalesInvoice: "/invoices/sale/new",
    salesInvoices: "/invoices/sale",

    recognisePurchaseInvoices: "/recognise/purchase/invoice",
    reviewPurchaseInvoices: "/review/invoices/purchase",
    reviewPurchaseInvoicesTaskId: "/review/invoices/purchase/:id",

    reviewSalesInvoices: "/review/invoices/sale",
    reviewSalesInvoicesTaskId: "/review/invoices/sale/:id",

    communicateViaEmail: "/accountant/communication/email",

    driveRedirect: "/redirect/drive",
}